import { useEffect, FC } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import cx from 'classnames';
import { useStyles } from './dxp-backdrop.tss';
import dompurify from 'dompurify';
import { useTheme } from '@mui/material';

const toggleBackdrop = (isLoading = true, appSelector = ''): void => {
  const selector: HTMLElement | null = appSelector !== '' ? document?.querySelector(appSelector) || null : null;
  const materialBox: HTMLElement | null = selector?.closest('.material-box') || null;
  const savedPerspective: string | null = selector?.getAttribute('data-material-box-perspective') || null;
  const materialBoxPerspective: string | null = materialBox ? window.getComputedStyle(materialBox).perspective : null;
  if (
    selector &&
    materialBoxPerspective &&
    materialBoxPerspective !== 'unset' &&
    materialBoxPerspective !== 'none' &&
    !savedPerspective
  ) {
    selector.dataset.materialBoxPerspective = materialBoxPerspective;
  }
  if (isLoading) {
    if (materialBox) {
      materialBox.style.overflow = 'hidden';
      if (savedPerspective) {
        materialBox.style.perspective = 'unset';
      }
    }
  } else if (materialBox) {
    materialBox.style.overflow = 'auto';
    if (savedPerspective) {
      materialBox.style.perspective = savedPerspective;
    }
  }
};

const DxpBackdrop: FC<TimApp.IAppBackdrop> = ({
  appSelector,
  appLoading,
  isLoading,
  additionalInfoTranslation,
  inPopup = true,
}) => {
  const { classes } = useStyles({ theme: useTheme() });

  const sanitizer = dompurify.sanitize;

  useEffect(() => {
    toggleBackdrop(isLoading, appSelector || '');
  }, [isLoading, appSelector]);

  useEffect(() => {
    return () => {
      toggleBackdrop(false, appSelector || '');
    };
  }, []);

  return (
    <Backdrop className={classes.backdrop} open={isLoading}>
      {isLoading && (
        <Box
          className={cx(
            classes.progressWrapper,
            appLoading ? classes.loading : classes.loaded,
            !appLoading && inPopup && classes.loadedInPopup
          )}
        >
          <div className={classes.loader} />
          {additionalInfoTranslation && (
            <span
              className={classes.additionalInfo}
              dangerouslySetInnerHTML={{
                __html: sanitizer(additionalInfoTranslation),
              }}
            />
          )}
        </Box>
      )}
    </Backdrop>
  );
};

export default DxpBackdrop;
